/**
 * Next.js의 useRouter() 훅의 query 객체 내의 키에 대한 값으로 플러스 부호가 빈 여백으로 변환되는 문제를 해결하기 위한 함수
 */

type ParseQueryString = (str: string) => string;

export const parseQueryString: ParseQueryString = (str) => {
  if (!str) {
    return '';
  }

  return str.replace(/\s+/g, '+');
};
